import { generateResourceReducer } from '../generators/resource.reducer';

import * as types from './settings.types';
import * as constants from './settings.constants';

export const settingsReducer = generateResourceReducer<types.ISettings>({
  STORE: constants.STORE_SETTINGS,
  CLEAR: constants.CLEAR_SETTINGS,
});
